export default function StatTile({ label, value, sub, accent, testId }) {
  return (
    <div
      className="surface rounded-lg p-4 flex flex-col gap-1"
      data-testid={testId}
    >
      <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-gray-500">
        {label}
      </div>
      <div
        className="font-display font-black text-3xl leading-none mt-1"
        style={accent ? { color: accent } : undefined}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
    </div>
  );
}
